module.exports = __webpack_public_path__ + "static/media/kickin.12f481fc.jpg";